export interface NavLink {
  label: string;
  href: string;
  external?: boolean;
  live?: boolean;
}

export interface NavCopy {
  links: readonly NavLink[];
}

export const NAV_EN: NavCopy = {
  links: [
    { label: 'Pricing', href: '/pricing' },
    { label: 'Trust',   href: '/trust', live: true },
  ],
};
